<li
    id="settings-menu"
    class="dropdown"
    data-bs-toggle="tooltip"
    data-bs-placement="bottom"
    title="Settings">
    <a
        class="btn dropdown-toggle"
        data-bs-toggle="dropdown"
        role="button"
        aria-label="Settings">
        <i class="fa fa-gear"></i>
    </a>
    <ul class="dropdown-menu dropdown-menu-end">
        <li
            role="presentation"
            class="dropdown-header">
            Settings
        </li>

        @if (isLicensedOrg && !isPrivateLabel) {
            <li>
                <a routerLink="/settings/licensedplan">
                    <i
                        class="fa fa-credit-card"
                        aria-hidden="true"></i>
                    Licensed Plan
                </a>
            </li>
        }
        <li>
            <a routerLink="/settings/addons">
                <i
                    class="fa fa-print"
                    aria-hidden="true"></i>
                Add-Ons
            </a>
        </li>
        @if (!currentUser().isNetworkAdmin) {
            <li>
                <a routerLink="/settings/users">
                    <i
                        class="fa fa-users"
                        aria-hidden="true"></i>
                    Users
                </a>
            </li>
        }

        <li>
            <a routerLink="/settings/organization">
                <i
                    class="fa fa-building-o"
                    aria-hidden="true"></i>
                Organization
            </a>
        </li>
        <li>
            <a routerLink="/settings/contacts">
                <i
                    class="fa fa-id-card-o"
                    aria-hidden="true"></i>
                Contacts
            </a>
        </li>
        <li *kno2FeatureToggle="['EnableExternalEFaxAccount']">
            <a routerLink="/settings/efaxaccount">
                <i
                    class="fa fa-fax"
                    aria-hidden="true"></i>
                eFax Account
            </a>
        </li>
        <li>
            <a routerLink="/settings/api">
                <i
                    class="fa fa-exchange"
                    aria-hidden="true"></i>
                API
            </a>
        </li>
        <li *kno2FeatureToggle="['WhitelistIpAddressesUI']">
            <a routerLink="/settings/ipaddresses">
                <i
                    class="fa fa-map-marker"
                    aria-hidden="true"></i>
                IP Addresses
            </a>
        </li>
        <li *kno2FeatureToggle="['PointClickCareIdentityProvider']">
            <a routerLink="/settings/identityproviders">
                <i
                    class="fa fa-id-badge"
                    aria-hidden="true"></i>
                Identity Providers
            </a>
        </li>
        <li
            role="presentation"
            class="dropdown-header">
            Document Sources
        </li>

        <li>
            <a routerLink="/settings/directaddresses">
                <i
                    class="fa fa-at"
                    aria-hidden="true"></i>
                Addresses
            </a>
        </li>

        <li *kno2FeatureToggle="['FaxDocumentSource']">
            <a routerLink="/settings/fax">
                <i
                    class="fa fa-fax"
                    aria-hidden="true"></i>
                Fax Numbers
            </a>
        </li>

        @if (currentUser().isNetworkAdmin) {
            <li
                role="presentation"
                class="dropdown-header">
                Network
            </li>
            <li>
                <a routerLink="/settings/users">
                    <i
                        class="fa fa-users"
                        aria-hidden="true"></i>
                    Network Users
                </a>
            </li>
            <li *kno2NetworkFeatureToggle="['SSO']">
                <a routerLink="/settings/network/identityprovider">
                    <i
                        class="fa fa-id-badge"
                        aria-hidden="true"></i>
                    Identity Provider
                </a>
            </li>
        }

        <li
            role="presentation"
            class="dropdown-header">
            Interoperability
        </li>

        <li>
            <a routerLink="/settings/documenttypes">
                <i
                    class="fa fa-file-text"
                    aria-hidden="true"></i>
                <span class="text">Document Types</span>
            </a>
        </li>
        <li>
            <a routerLink="/settings/cdadocumenttypes">
                <i
                    class="fa fa-list"
                    aria-hidden="true"></i>
                <span class="text">CDA Document Types</span>
            </a>
        </li>
        <li>
            <a routerLink="/settings/rules">
                <i
                    class="fa fa-sliders"
                    aria-hidden="true"></i>
                <span class="text">Intake Rules</span>
            </a>
        </li>
        <li *kno2FeatureToggle="['MessageDownloadClient']">
            <a routerLink="/settings/downloadprofiles">
                <i
                    class="fa fa-cloud-download"
                    aria-hidden="true"></i>
                <span class="text">Download Profiles</span>
            </a>
        </li>
        <li>
            <a routerLink="/settings/exports">
                <i
                    class="fa fa-download"
                    aria-hidden="true"></i>
                <span class="text">Intake Download</span>
            </a>
        </li>
        <li>
            <a routerLink="/settings/releasetypes">
                <i
                    class="fa fa-upload"
                    aria-hidden="true"></i>
                <span class="text">Configure Releases</span>
            </a>
        </li>
    </ul>
</li>
